import { defineNuxtPlugin, useQueryClient } from '#imports'

export default defineNuxtPlugin({
    name: 'query-retention',
    hooks: {
        // Queries only fall inactive when their component unmounts, which in practice means
        // a navigation — so the sweep rides page:finish instead of a permanent interval.
        'page:finish': function () {
            useQueryClient().releaseInactiveQueries()
        },
    },
})
